var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [_c("divider", { attrs: { label: "Dados do Processo" } })],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12, lg: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Número do Processo:", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value: _vm.processo.numeroProcesso,
                  callback: function($$v) {
                    _vm.$set(_vm.processo, "numeroProcesso", $$v)
                  },
                  expression: "processo.numeroProcesso"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12, lg: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Município:", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true },
                model: {
                  value:
                    _vm.processo.cadastroColetivo.pecaTecnica.municipios[0]
                      .nome,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.processo.cadastroColetivo.pecaTecnica.municipios[0],
                      "nome",
                      $$v
                    )
                  },
                  expression:
                    "processo.cadastroColetivo.pecaTecnica.municipios[0].nome"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12, lg: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Nome da Gleba:", required: true }
              }),
              _c("el-input", {
                staticClass: "input ellipsis",
                attrs: { disabled: true },
                model: {
                  value: _vm.processo.cadastroColetivo.pecaTecnica.gleba,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.processo.cadastroColetivo.pecaTecnica,
                      "gleba",
                      $$v
                    )
                  },
                  expression: "processo.cadastroColetivo.pecaTecnica.gleba"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12, lg: 8 } },
            [
              _c("app-label", {
                attrs: { label: "Área total:", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: true, value: _vm.area }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58c4f2ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c4f2ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/DadosProcesso.vue
// module id = null
// module chunks = 